import Vue from 'vue';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';

Vue.config.productionTip = false;

Vue.use(CludoVue, {
  store: store,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 12211,
    // cludoEngineId: 11278, // Course/Programme Engine ID
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 500,
    paginationRange: 2,
    sortOnLoad: { Title: 'asc' },
    payload: {
      filters: {
        Category: ['Course'],
        StudyLevel: ['Undergraduate'],
        // StudyYear: ['2024', '2025'],
      },
      // postFiltersOperator: 'or',
    },
  },
});

new Vue({
  render: (h) => h(App),
  store: store,
}).$mount('#ug-programme-search');
